module.exports = __webpack_public_path__ + "static/media/recent-bg.767acf9d.png";